import React from 'react';
import SettingsLogs from "@/features/settings-logs/SettingsLogs";
import { Stack } from "@chakra-ui/react";

const SettingsLogsPage = () => {
  return (
    <Stack gap={5}>
      <SettingsLogs />
    </Stack>
  );
};
export default SettingsLogsPage;
